import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import constants from '../../constants/HeaderTranslation.json';
import filterConstants from '../../constants/FilterTranslation.json';

export default class FilterDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dropownOpen: false };
  }

  componentWillUnmount() {
    if (this.state.dropownOpen) document.removeEventListener('click', this.handleOutsideClick);
  }

  toggleDropdown = () => {
    // attach/remove event handler
    !this.state.dropownOpen
      ? document.addEventListener('mousedown', this.handleOutsideClick)
      : document.removeEventListener('mousedown', this.handleOutsideClick);

    if (this.props.setDropdownState) this.props.setDropdownState(!this.state.dropownOpen);
    this.setState(prevState => ({ dropownOpen: !prevState.dropownOpen }));
  };

  handleOutsideClick = event => {
    // ignore clicks on the component itself
    if (this.node.contains(event.target)) {
      return;
    }
    this.toggleDropdown();
  };

  changeOption = id => {
    this.props.updateFilterOption({
      sectionKey: this.props.sectionKey,
      optionId: id,
    });
    this.toggleDropdown();
  };

  selected = key => (key === this.props.optionId ? 'selected' : '');

  getDisplayText = () => {
    if (this.props.filterCustomReferenceId === 11) {
      return this.props.optionId === 6
        ? filterConstants.updated_at_within
        : filterConstants.updated_at_since;
    }
    return constants.filterDropdown[this.props.optionId];
  };

  rows = () => {
    const { filterCustomReferenceId, hasExistingValues } = this.props;

    // For UPDATED_AT filter (reference ID 11)
    if (filterCustomReferenceId === 11) {
      if (hasExistingValues) {
        // Only show current option when filter is already configured
        const currentOptionId = this.props.optionId;
        const currentOptionName =
          currentOptionId === 6
            ? filterConstants.updated_at_within
            : filterConstants.updated_at_since;
        return [
          <div
            key={currentOptionId}
            className={`row ${this.selected(currentOptionId)}`}
            onClick={() => this.changeOption(currentOptionId)}
          >
            {currentOptionName}
          </div>,
        ];
      }
      // Show both within/since options when no filter configured yet
      return [
        <div key={6} className={`row ${this.selected(6)}`} onClick={() => this.changeOption(6)}>
          {filterConstants.updated_at_within}
        </div>,
        <div key={7} className={`row ${this.selected(7)}`} onClick={() => this.changeOption(7)}>
          {filterConstants.updated_at_since}
        </div>,
      ];
    }

    // Standard options for other filters
    return [1, 2, 3, 4, 5].map(id => (
      <div key={id} className={`row ${this.selected(id)}`} onClick={() => this.changeOption(id)}>
        {constants.filterDropdown[id]}
      </div>
    ));
  };

  optionList = () => {
    if (this.state.dropownOpen) {
      return (
        <div
          className="pdm-table header__filter-dropdown_options"
          style={{ transform: `translate(-${this.props.position}px)` }}
        >
          {this.rows()}
        </div>
      );
    }
  };

  render() {
    return (
      <div className="header__filter-dropdown" ref={node => (this.node = node)}>
        <div className="header__filter-dropdown_option">{this.getDisplayText()}</div>
        <CaretDownOutlined
          className="header__dropdown-icon"
          onClick={() => this.toggleDropdown()}
        />
        {this.optionList()}
      </div>
    );
  }
}

FilterDropdown.defaultProps = {
  optionId: 0,
};
